import { createThemedStyles } from "@fresh8/vue-jss/src/theme";
export type Theme = {};
const { createUseStyles, provideTheme, injectTheme } = createThemedStyles<
  Theme
>();
export { createUseStyles, provideTheme, injectTheme };
